const Footer = () => {
  return (
    <footer
      className="footer"
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "#495057",
        color: "white",
        padding: "2px 0",
        textAlign: "center",
        borderTop: "1px solid #e7e7e7",
      }}
    >
      <div className="container">
        <p style={{ marginTop: "5px", marginBottom: "5px" }}>
          Copyright © 2025ONGC. All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
